import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { debounce } from 'lodash';
import React from 'react';
import { Controller } from 'react-hook-form';
import styled, { useTheme } from 'styled-components';
import { CommonAutocompleteProps } from './InputInterface';
import { CarInformation } from 'pages/tradeIn/TradeInInterface';
import { useTranslation } from 'react-i18next';
import { ru } from 'date-fns/locale';
import { FormControl, FormHelperText } from '@mui/material';

const AutocompleteInput = styled((props: CommonAutocompleteProps) => {
  const { ...rest } = props;
  return <TextField {...rest} />;
})`
  & .MuiInputBase-root {
    background-color: ${(props) =>
      props.textInputVariant === 'outline' ? props.theme.colors.whiteColor : props.theme.colors.whiteColor};
    .MuiOutlinedInput-notchedOutline {
      border-color: ${(props) =>
        props.textInputVariant === 'outline' ? props.theme.colors.whiteColor : props.theme.colors.inputBorder};
    }
    .MuiAutocomplete-input {
      padding: 1px !important;
    }
    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) =>
          props.textInputVariant === 'outline' ? props.theme.colors.whiteColor : props.theme.colors.inputBorder};
      }
    }
  }
`;

const StyledDropdownContainer = styled((props: any) => {
  const { ...rest } = props;
  return <div {...rest} />;
})`
  background-color: ${(props) => props.theme.colors.whiteColor};
`;

const StyledDropdownList = styled((props: any) => {
  const { ...rest } = props;
  return <li {...rest} />;
})`
  // font-size: 12px;
`;

const CommonAutocomplete: React.FC<CommonAutocompleteProps> = ({
  control,
  name,
  fetchOptions,
  filteredData,
  placeholder,
  getSelectedVal,
  textInputVariant = 'outline',
  label,
  rules,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValues] = React.useState<object | null>(null);

  const handleSearch = debounce(async (searchText: string) => {
    fetchOptions(searchText);
  }, 400);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=''
      rules={rules}
      render={({ field, formState: { errors } }) => (
        <>
          {label ? <label className='control-label'>{label}</label> : null}
          <Autocomplete
            {...field}
            autoComplete={false}
            value={value}
            onChange={(event: any, newValue: CarInformation) => {
              console.log('newValue', newValue);
              if (newValue !== null) {
                setValues(newValue);
                getSelectedVal && getSelectedVal(newValue);
              }
            }}
            ListboxProps={{
              style: {
                // maxHeight: '120px',
                border: `1px solid ${theme.colors.lightBorder}`,
                backgroundColor: theme.colors.whiteColor,
              },
            }}
            options={filteredData?.length ? filteredData : []}
            filterOptions={(options, state) => {
              const lowerCaseSearchTerms = state.inputValue.toLowerCase().split(' ');

              const displayOptions = filteredData?.filter((film) =>
                lowerCaseSearchTerms.every((term) => film.description.toLowerCase().includes(term))
              );

              return displayOptions;
            }}
            getOptionLabel={(option) => option?.description}
            onInputChange={(_, newInputValue) => {
              newInputValue && handleSearch(newInputValue);
            }}
            PaperComponent={({ children }) => <StyledDropdownContainer>{children}</StyledDropdownContainer>}
            renderOption={(props, option) => <StyledDropdownList {...props}>{option?.description}</StyledDropdownList>}
            noOptionsText={
              filteredData?.length === 0 ? t('stepperFormTradeIn.search') : t('stepperFormTradeIn.noOptions')
            }
            renderInput={(params) => (
              <AutocompleteInput
                {...params}
                InputLabelProps={{ shrink: false }}
                placeholder={placeholder}
                variant='outlined'
                textInputVariant={textInputVariant}
              />
            )}
          />
          {errors?.[name] && <FormHelperText>{errors?.[name]?.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default CommonAutocomplete;
